import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

interface MobileAppModalState {
	dismissed: boolean
}

const initialState = {
	dismissed: false,
} as MobileAppModalState

export const mobileAppModalSlice = createSlice({
	name: 'mobileAppModal',
	initialState,
	reducers: {
		setMobileAppModalDismissed: (state, action: PayloadAction<boolean>) => {
			state.dismissed = action.payload
		},
	},
})

export const {
	setMobileAppModalDismissed,
} = mobileAppModalSlice.actions

export default mobileAppModalSlice.reducer